"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.default = (function (virtual) { return function (data) {
    var fields = virtual.protocol.fields;
    var cmds = virtual.protocol.cmds;
    var cmdId = data.cmdId === undefined ? utils_1.find(Object.keys(cmds), function (key) { return cmds[key].cmdTag === data.cmdTag; }) : data.cmdId;
    var cmd = cmdId === undefined ? undefined : cmds[cmdId];
    if (!cmd) {
        return data;
    }
    return cmd.fields.reduce(function (val, field) {
        if (fields[field].dataType === 'STRING') {
            val[field] = data[field] !== undefined && data[field] !== null ? data[field] : '';
        }
        else {
            val[field] = typeof data[field] === 'number'
                ? utils_1.getCorrectVal(data[field], fields[field])
                : utils_1.getValFromProtocol(fields[field]);
        }
        return val;
    }, { cmdId: cmd.cmdId });
}; });



// WEBPACK FOOTER //
// ./src/encode/jsonCtrl.ts